import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((config) => {
  const t = localStorage.getItem("doctor_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export const api = {
  departments: () => client.get("/departments").then((r) => r.data),
  doctors: (dept) => client.get("/doctors", { params: dept ? { department: dept } : {} }).then((r) => r.data),
  slots: (id) => client.get(`/doctors/${id}/slots`).then((r) => r.data),
  triage: (payload) => client.post("/ai/triage", payload).then((r) => r.data),
  book: (payload) => client.post("/appointments", payload).then((r) => r.data),
  lookup: (q) => client.get("/appointments/lookup", { params: { q } }).then((r) => r.data),
  transferRebook: (payload) => client.post("/transfer-rebook", payload).then((r) => r.data),

  // doctor
  doctorLogin: (payload) => client.post("/auth/doctor/login", payload).then((r) => r.data),
  doctorMe: () => client.get("/auth/doctor/me").then((r) => r.data),
  doctorAppts: () => client.get("/doctor/appointments").then((r) => r.data),
  updateStatus: (id, status) => client.patch(`/appointments/${id}/status`, { status }).then((r) => r.data),
  toggleSlot: (date, enabled) => client.post("/doctor/schedule/toggle", { date, enabled }).then((r) => r.data),
  getSchedule: () => client.get("/doctor/schedule").then((r) => r.data),
  emergencyCancel: (date) => client.post("/doctor/emergency-cancel", { date }).then((r) => r.data),
  updateProfile: (body) => client.patch("/auth/doctor/profile", body).then((r) => r.data),
};
